export var RegexConfig;
(function (RegexConfig) {
    RegexConfig["EMAIL"] = "^^[a-zA-Z0-9._{|}-]*@[a-zA-Z0-9]+.^[A-Za-z]+${2,}$";
    RegexConfig["MOBILE"] = "^[0-9]*$";
    RegexConfig["NEW_MOBILE"] = "^[0-9]{10}$";
    RegexConfig["PAN"] = "^[A-Z]{5}[0-9]{4}[A-Z]{1}$";
    RegexConfig["AADHAR"] = "^[2-9]{1}[0-9]{11}$";
    RegexConfig["ONLY_NUMBER"] = "^[0-9]*$";
    RegexConfig["NEW_EMAIL"] = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$";
    RegexConfig["IFSC"] = "^[A-Z]{4}0[A-Z0-9]{6}$";
    RegexConfig["NAME"] = "^(?!.*[\uD83C-\uDBFF\uDC00-\uDFFF]).*$\n";
})(RegexConfig || (RegexConfig = {}));
export var LENDER_ID;
(function (LENDER_ID) {
    LENDER_ID["TATA"] = "tata";
    LENDER_ID["MIRAE"] = "mirae";
    LENDER_ID["BAJAJ"] = "bajaj";
    LENDER_ID["NUVAMA"] = "nuvama";
    LENDER_ID["DSP"] = "dsp";
})(LENDER_ID || (LENDER_ID = {}));
export var PLATFORM_NAME;
(function (PLATFORM_NAME) {
    PLATFORM_NAME["TDL"] = "TATADIGITAL";
    PLATFORM_NAME["PHONEPE"] = "PHONEPE";
})(PLATFORM_NAME || (PLATFORM_NAME = {}));
export var DSP_PAYMENT_STATUS;
(function (DSP_PAYMENT_STATUS) {
    DSP_PAYMENT_STATUS["SUCCESS"] = "SUCCESS";
    DSP_PAYMENT_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
    DSP_PAYMENT_STATUS["FAILED"] = "FAILED";
    DSP_PAYMENT_STATUS["CANCELLED"] = "CANCELLED";
    DSP_PAYMENT_STATUS["EXEEDED"] = "EXEEDED";
})(DSP_PAYMENT_STATUS || (DSP_PAYMENT_STATUS = {}));
export var UPDATE_REQUEST_TYPE;
(function (UPDATE_REQUEST_TYPE) {
    UPDATE_REQUEST_TYPE["PHONE_NUMBER"] = "PHONE_NUMBER";
    UPDATE_REQUEST_TYPE["EMAIL"] = "EMAIL";
})(UPDATE_REQUEST_TYPE || (UPDATE_REQUEST_TYPE = {}));
export var UPDATE_STATUS_TYPE;
(function (UPDATE_STATUS_TYPE) {
    UPDATE_STATUS_TYPE["REQUESTED"] = "REQUESTED";
    UPDATE_STATUS_TYPE["SUCCESS"] = "SUCCESS";
    UPDATE_STATUS_TYPE["REJECTED"] = "REJECTED";
    UPDATE_STATUS_TYPE["FAILURE"] = "FAILURE";
})(UPDATE_STATUS_TYPE || (UPDATE_STATUS_TYPE = {}));
export var INTEREST_REPAYMENT_STATUS;
(function (INTEREST_REPAYMENT_STATUS) {
    INTEREST_REPAYMENT_STATUS["AWAITING_MANDATE_STATUS"] = "AWAITING_MANDATE_STATUS";
    INTEREST_REPAYMENT_STATUS["DUE"] = "DUE";
    INTEREST_REPAYMENT_STATUS["FAILED"] = "FAILED";
    INTEREST_REPAYMENT_STATUS["OVERDUE"] = "OVERDUE";
    INTEREST_REPAYMENT_STATUS["SETTLED"] = "SETTLED";
    INTEREST_REPAYMENT_STATUS["HARD_DATE_BREACHED"] = "HARD_DATE_BREACHED";
})(INTEREST_REPAYMENT_STATUS || (INTEREST_REPAYMENT_STATUS = {}));
export var REPAYMENT_COLLECTION_TYPE;
(function (REPAYMENT_COLLECTION_TYPE) {
    REPAYMENT_COLLECTION_TYPE["LOAN_EXPIRED_DUE_REPAYMENT"] = "LOAN_EXPIRED_DUE_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["PRINCIPAL_REPAYMENT"] = "PRINCIPAL_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["IN_APP_INTEREST_COLLECTION"] = "IN_APP_INTEREST_COLLECTION";
    REPAYMENT_COLLECTION_TYPE["SHORTFALL_REPAYMENT"] = "SHORTFALL_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["FORECLOSURE"] = "FORECLOSURE";
})(REPAYMENT_COLLECTION_TYPE || (REPAYMENT_COLLECTION_TYPE = {}));
export var FORECLOSURE_STATUS;
(function (FORECLOSURE_STATUS) {
    FORECLOSURE_STATUS["IN_REVIEW"] = "IN_REVIEW";
    FORECLOSURE_STATUS["QUEUED"] = "QUEUED";
    FORECLOSURE_STATUS["REQUESTED"] = "REQUESTED";
    FORECLOSURE_STATUS["PENDING_LENDER_APPROVAL"] = "PENDING_LENDER_APPROVAL";
    FORECLOSURE_STATUS["SUCCESS"] = "SUCCESS";
    FORECLOSURE_STATUS["FAILED"] = "FAILED";
    FORECLOSURE_STATUS["REJECTED"] = "REJECTED";
})(FORECLOSURE_STATUS || (FORECLOSURE_STATUS = {}));
